export default class setMultiLingualDemoPage {
  constructor() {
    this.selector = 'link[rel="alternate"][hreflang="zh-cn"]';
  }

  async bootstrap() {
    const links = document.querySelectorAll(this.selector);

    if (!links.length) return;

    for (const link of links) {
      if (!link.href.startsWith('https://www.singular.net/zh-cn/')) {
        continue;
      }

      const newUrl = link.href.replace(
        /^https:\/\/www\.singular\.net\/zh-cn\//,
        'https://www.singular-cn.net/'
      );

      const exists = await this.urlExists(newUrl);

      if (exists) {
        link.href = newUrl;
      } else {
        link.remove();
      }
    }
  }

  async urlExists(url) {
    try {
      const response = await fetch(url, {
        method: 'HEAD',
        mode: 'no-cors' // avoids hard CORS failures
      });

      // If fetch doesn't throw, we assume it exists
      return response.ok || response.type === 'opaque';
    } catch (e) {
      return false;
    }
  }
}
